import { render } from "./application.vue?vue&type=template&id=efef55f2&scoped=true"
import script from "./application.vue?vue&type=script&lang=js"
export * from "./application.vue?vue&type=script&lang=js"

import "./application.vue?vue&type=style&index=0&id=efef55f2&scoped=true&lang=css"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efef55f2"]])

export default __exports__